import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const SimCategoryList = (props) => {
  const renderItem = (item, index) => {
    const ItemComponent = props.itemComponent
    const isSortable = props.isSortable

    const allProps = {
      ...item,
      ...props.itemExtraProps,
    }

    return (
      <Fragment>
        {!isSortable && (
          <div className='hidden'  />
        )}
        <ItemComponent
          key={ index }
          { ...allProps }
        />
      </Fragment>
    )
  }

  return (
    <div className='category_list_sim_golf'>
      <div>
        {props.items.map((item, index) => (
          <div key={ index }>
            { renderItem({ ...item, index })}
          </div>
        ))}
      </div>
    </div>
  )
}

SimCategoryList.propTypes = {
  items: PropTypes.array.isRequired,
  isSortable: PropTypes.bool,
  onSortEnd: PropTypes.func,
  onNestedSortEnd: PropTypes.func,
  itemExtraProps: PropTypes.object,
  itemComponent: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.func.isRequired,
  ]).isRequired,
}

SimCategoryList.defaultProps = {
  isSortable: false,
}

export default SimCategoryList